//1. import
import '../../scss/pages/events.scss';
import {initializeCollaborationsSliders } from '../sections/collaborations.js';
import {initializeEventListingSliders}from '../sections/event-listings.js';
import { eventWelcome } from '../sections/event-welcome.js';

//2. Event listeners
document.addEventListener("DOMContentLoaded", function () { 
    eventWelcome();
    initializeEventListingSliders();
    initializeCollaborationsSliders();
});

//3.Function


